export const dotsList = [
  {
    start: { lat: 37.7749, lng: -122.4194 }, // San Francisco
    end: { lat: 40.7128, lng: -74.006 }, // New York
  },
  {
    start: { lat: 51.5074, lng: -0.1278 }, // London
    end: { lat: 48.8566, lng: 2.3522 }, // Paris
  },
];
